import { show, hide } from '../../../util/show'

function updateSpotifyToggle() {
  const toggleRssCheckbox = document.querySelector('#publication_podcast_settings_activated')
  const toggleSpotifyCheckbox = document.querySelector('#publication_publish_on_spotify')
  const hasSpotifyPlansError = !!document.getElementById('error_description_publication_plans_with_spotify_access_ids')
  const forceDisableSpotifyCheckbox = !!document.querySelector(
    "#publication_publish_on_spotify[data-force-disabled='true']"
  )

  if (toggleRssCheckbox.checked || hasSpotifyPlansError) {
    toggleSpotifyCheckbox.removeAttribute('disabled')
  } else {
    toggleSpotifyCheckbox.setAttribute('disabled', 'disabled')
    toggleSpotifyCheckbox.checked = false
  }

  if (forceDisableSpotifyCheckbox) {
    toggleSpotifyCheckbox.setAttribute('disabled', 'disabled')
  }

  updateSpotifyPlansContainerVisibility()
}

function updateSpotifyPlansContainerVisibility() {
  const toggleSpotifyCheckbox = document.querySelector('#publication_publish_on_spotify')
  const spotifyPlansContainer = document.querySelector('.js-spotify_plans_container')
  const hasSpotifyPlansError = !!document.getElementById('error_description_publication_plans_with_spotify_access_ids')

  if (!spotifyPlansContainer) {
    return
  }

  if (toggleSpotifyCheckbox.checked || hasSpotifyPlansError) {
    show(spotifyPlansContainer)
  } else {
    hide(spotifyPlansContainer)
  }
}

function updateSpotifyRemovalWarningVisibility() {
  const toggleSpotifyCheckbox = document.querySelector('#publication_publish_on_spotify')
  const spotifyRemovalWarning = document.querySelector('.js-spotify_removal_warning')

  if (!spotifyRemovalWarning) {
    return
  }

  if (toggleSpotifyCheckbox.checked) {
    hide(spotifyRemovalWarning)
  } else {
    show(spotifyRemovalWarning)
  }
}

up.compiler('#publication_podcast_settings_activated', function (element) {
  updateSpotifyToggle()

  element.addEventListener('change', function () {
    updateSpotifyToggle()
  })
})

up.compiler('#publication_publish_on_spotify', function (element) {
  updateSpotifyPlansContainerVisibility()
  updateSpotifyRemovalWarningVisibility()

  element.addEventListener('change', function () {
    updateSpotifyPlansContainerVisibility()
    updateSpotifyRemovalWarningVisibility()
  })
})
